<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0">
        <div class="card-body p-3">
          <!-- Header Section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div class="d-flex align-items-center">
              <button class="btn btn-icon me-3 border" routerLink="/party-visits">
                <i class="bi bi-arrow-left"></i>
              </button>
              <div>
                <h1 class="card-title mb-1">
                  {{ employeeObj?.user?.first_name }} {{ employeeObj?.user?.last_name }}'s Visits
                </h1>
                <span class="sub-text">Managing and tracking party visit records</span>
              </div>
            </div>

            <div class="d-flex gap-2 mt-2 mt-md-0">
              <button
                class="btn btn-soft-primary btn-sm"
                (click)="onExportVisits()"
                [disabled]="isExportingVisits || isApplyDisabled">
                @if (isExportingVisits) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export
                }
              </button>
            </div>
          </div>

          <!-- Filters Section -->
          <app-error-alert [error]="generalError"></app-error-alert>

          <div class="bg-light p-3 border mb-4">
            <div class="row g-3 align-items-start">
              <div class="col-md-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Visit Status</label>
                <ng-select
                  placeholder="All Statuses"
                  [items]="visitStatuses"
                  [(ngModel)]="selectedStatus"
                  [clearable]="true"
                  [searchable]="false" />
              </div>

              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase">Dealer</label>
                <ng-select
                  placeholder="All Dealers"
                  [items]="dealersList"
                  [(ngModel)]="selectedDealer"
                  bindValue="id"
                  bindLabel="shop_name"
                  [clearable]="true"
                  [searchable]="true" />
              </div>

              <div class="col-md-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Filter By</label>
                <ng-select
                  [items]="dateFilterModes"
                  [(ngModel)]="dateFilterMode"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="false"
                  [searchable]="false"
                  (ngModelChange)="onDateFilterModeChange()" />
              </div>
            </div>

            @if (dateFilterMode !== 'all') {
              <div class="row g-3 align-items-start mt-0">
                @if (dateFilterMode === 'date') {
                  <div class="col-md-3">
                    <label class="form-label small fw-bold text-muted text-uppercase">Date</label>
                    <input
                      type="date"
                      class="form-control"
                      [class.is-invalid]="errorFor('date')"
                      [(ngModel)]="dateFilters.date"
                      (ngModelChange)="onFilterInputChange()" />
                    @if (errorFor('date')) {
                      <div class="invalid-feedback d-block">{{ errorFor('date') }}</div>
                    }
                  </div>
                }

                @if (dateFilterMode === 'range') {
                  <div class="col-md-3">
                    <label class="form-label small fw-bold text-muted text-uppercase">From</label>
                    <input
                      type="date"
                      class="form-control"
                      [class.is-invalid]="errorFor('start_date')"
                      [(ngModel)]="dateFilters.start_date"
                      (ngModelChange)="onFilterInputChange()" />
                    @if (errorFor('start_date')) {
                      <div class="invalid-feedback d-block">{{ errorFor('start_date') }}</div>
                    }
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small fw-bold text-muted text-uppercase">To</label>
                    <input
                      type="date"
                      class="form-control"
                      [class.is-invalid]="errorFor('end_date')"
                      [(ngModel)]="dateFilters.end_date"
                      (ngModelChange)="onFilterInputChange()" />
                    @if (errorFor('end_date')) {
                      <div class="invalid-feedback d-block">{{ errorFor('end_date') }}</div>
                    }
                  </div>
                }

                @if (dateFilterMode === 'month_year') {
                  <div class="col-md-3">
                    <label class="form-label small fw-bold text-muted text-uppercase">Month</label>
                    <ng-select
                      placeholder="Select month"
                      [items]="monthOptions"
                      [(ngModel)]="dateFilters.month"
                      bindValue="value"
                      bindLabel="label"
                      [clearable]="true"
                      [searchable]="false"
                      (ngModelChange)="onFilterInputChange()" />
                    @if (errorFor('month')) {
                      <div class="invalid-feedback d-block">{{ errorFor('month') }}</div>
                    }
                  </div>
                }

                @if (dateFilterMode === 'month_year' || dateFilterMode === 'year') {
                  <div class="col-md-3">
                    <label class="form-label small fw-bold text-muted text-uppercase">Year</label>
                    <ng-select
                      placeholder="Select year"
                      [items]="partyVisitsYears"
                      [(ngModel)]="dateFilters.year"
                      [clearable]="dateFilterMode === 'month_year'"
                      [searchable]="false"
                      (ngModelChange)="onFilterInputChange()" />
                    @if (errorFor('year')) {
                      <div class="invalid-feedback d-block">{{ errorFor('year') }}</div>
                    }
                  </div>
                }
              </div>
            }

            <div class="d-flex justify-content-end gap-2 mt-3">
              <button class="btn btn-soft-secondary btn-sm" (click)="onClearFilters()">
                <i class="bi bi-x-circle"></i>
                Clear filters
              </button>
              <button class="btn btn-soft-primary btn-sm" (click)="onApplyFilters()" [disabled]="isApplyDisabled">
                @if (isPartyVisitsLoading) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Applying...
                } @else {
                  <i class="bi bi-funnel"></i>
                  Apply
                }
              </button>
            </div>
          </div>

          @if (isDataLoading || isPartyVisitsLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            @for (day of groupedVisits; track day.date) {
              <div class="mb-4">
                <div class="bg-light px-3 py-2 border-start border-primary border-4 mb-2">
                  <span class="fw-bold text-dark">{{ day.date | date: 'fullDate' }}</span>
                </div>
                <div class="table-responsive bg-white border">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light border-bottom">
                      <tr>
                        <th class="px-3 border-0 text-uppercase small fw-bold text-muted py-2">Shop Name</th>
                        <th class="text-center border-0 text-uppercase small fw-bold text-muted py-2">Status</th>
                        <th class="text-center border-0 text-uppercase small fw-bold text-muted py-2">Type</th>
                        <th class="text-center border-0 text-uppercase small fw-bold text-muted py-2">Check In</th>
                        <th class="text-center border-0 text-uppercase small fw-bold text-muted py-2">Check Out</th>
                        <th class="text-center border-0 text-uppercase small fw-bold text-muted py-2">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (visit of day.visits; track visit.id) {
                        <tr>
                          <td class="px-3">
                            <span class="fw-bold text-dark">
                              {{ visit.dealer.shop_name }}
                            </span>
                          </td>
                          <td class="text-center">
                            <span class="app-badge text-white {{ getStatusBadgeClass(visit.visit_status) }}">
                              {{ visit.visit_status }}
                            </span>
                          </td>
                          <td class="text-center text-muted small">{{ visit.visit_type_display || '-' }}</td>
                          <td class="text-center text-muted small">
                            {{ visit.visit_check_in ? (visit.visit_check_in | date: 'shortTime') : '-' }}
                          </td>
                          <td class="text-center text-muted small">
                            {{ visit.visit_check_out ? (visit.visit_check_out | date: 'shortTime') : '-' }}
                          </td>
                          <td class="text-center">
                            <button
                              class="btn btn-sm btn-action-info"
                              (click)="viewVisitDetails(visit, visitDetailsModal)">
                              <i class="bi bi-eye"></i>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            } @empty {
              <div class="empty-state-container my-5">
                <i class="bi bi-person-walking"></i>
                <h5 class="text-dark fw-bold">No Party Visits Found</h5>
                <p class="text-muted">No party visit records found for this criteria.</p>
              </div>
            }

            @if (totalCount > 10) {
              <div class="mt-4">
                <app-pagination
                  [currentPage]="currentPage"
                  [totalCount]="totalCount"
                  [pageSize]="10"
                  [hasNextPage]="hasNextPage"
                  [hasPreviousPage]="hasPreviousPage"
                  (pageChange)="onPageChange($event)"></app-pagination>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #visitDetailsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Party Visit Details</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body p-4">
    <div class="row g-4">
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Dealer</label>
        <p class="fw-bold text-dark mb-0">
          {{ selectedVisit?.dealer?.shop_name }}
        </p>
        <p class="text-muted small mb-0">
          {{ selectedVisit?.dealer?.first_name }} {{ selectedVisit?.dealer?.last_name }}
        </p>
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Status</label>
        <span class="app-badge text-white {{ getStatusBadgeClass(selectedVisit?.visit_status || '') }}">
          {{ selectedVisit?.visit_status }}
        </span>
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Visit Type</label>
        <p class="text-dark mb-0">{{ selectedVisit?.visit_type_display || '-' }}</p>
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Follow Up Date</label>
        <p class="text-dark mb-0">
          {{ selectedVisit?.follow_up_date ? (selectedVisit?.follow_up_date | date: 'mediumDate') : '-' }}
        </p>
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Check In</label>
        <p class="text-dark mb-0">
          {{ selectedVisit?.visit_check_in ? (selectedVisit?.visit_check_in | date: 'medium') : '-' }}
        </p>
      </div>
      <div class="col-md-6">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Check Out</label>
        <p class="text-dark mb-0">
          {{ selectedVisit?.visit_check_out ? (selectedVisit?.visit_check_out | date: 'medium') : '-' }}
        </p>
      </div>
      <div class="col-12">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Visit Reasons</label>
        <div class="d-flex flex-wrap gap-2">
          @for (reason of selectedVisit?.visit_reasons_display; track reason) {
            <span class="badge bg-light text-dark border">{{ reason }}</span>
          } @empty {
            <span class="text-muted">No reasons provided</span>
          }
        </div>
      </div>
      <div class="col-12">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Remarks</label>
        <p class="text-dark mb-0 bg-light p-3 border rounded">
          {{ selectedVisit?.visit_remarks || 'No remarks provided' }}
        </p>
      </div>
      <div class="col-12">
        <label class="form-label small fw-bold text-muted text-uppercase d-block mb-1">Visit Image</label>
        @if (selectedVisit?.visit_image) {
          <img
            [src]="selectedVisit?.visit_image"
            alt="Visit Image"
            class="img-fluid rounded border shadow-sm"
            style="max-height: 300px; display: block" />
        } @else {
          <p class="text-muted mb-0">No image uploaded</p>
        }
      </div>
    </div>
  </div>
</ng-template>
